module.exports = __webpack_public_path__ + "static/media/0b9f9adb-b25a-457d-ba02-b238c7d2f668.fb2441d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/0b9f9adb-b25a-457d-ba02-b238c7d2f668.jpg
// module id = 799
// module chunks = 0